import { IServerOrder } from '@rbi-ctg/menu';

import type { PaymentFlowStore } from '../../../state/payment-stores/payment-flow-store';

export function getPlaceOrderButtonText(
  currentState: PaymentFlowStore['currentState'],
  hasRetryInfo: boolean,
  serverOrderLoading: boolean,
  serverOrderStatus?: IServerOrder['status']
) {
  if (serverOrderLoading || serverOrderStatus === 'PRICE_REQUESTED') {
    return 'Loading Prices...';
  }
  if (serverOrderStatus === 'INSERT_REQUESTED') {
    return 'Sending to Store...';
  }
  if (hasRetryInfo) {
    return 'Retry Place Order';
  }
  switch (currentState) {
    case 'encrypting':
      return 'Encrypting...';
    case 'validatingCart':
      return 'Checking Cart...';
    case 'serviceModeCheck':
    case 'committing':
    case 'vaulting':
      return 'Processing Order...';
    default:
      return 'Place Secure Order';
  }
}
